import { Grid } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import FamilyBar from "../../../components/cases/familyTree/FamilyBar";
import FamilyChart from "../../../components/cases/familyTree/FamilyChart";
import { getFtOnBoardingList } from "../../../redux/slices/features/ftOnBoardingSlice";
import { getTotalAuditTrials } from "../../../services/yourAssets/FamilyTreeServices";
import "../yourAssets.scss";

const AdvisorFamilyTree = () => {
  const { id } = useParams();
  const [trialsList, setTrialsList] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      dispatch(getFtOnBoardingList());
    })();

    const getListing = async () => {
      let result2 = await getTotalAuditTrials(id);
      const { payLoad = [] } = result2;
      if (result2.status === 204) {
      } else {
        setTrialsList(payLoad);
      }
    };
    getListing();
  }, []);

  return (
    <>
      <Grid
        container
        spacing={5}
        sx={{
          marginTop: "0.5rem",
        }}
        className="family-tree-grid"
      >
        <Grid item lg={8} md={12} sm={12} xs={12} className="left-side">
          <FamilyChart listTrials={trialsList} />
        </Grid>
        <Grid item lg={4} md={12} sm={12} xs={12} className="right-side">
          <FamilyBar trialsList={trialsList} />
        </Grid>
      </Grid>
    </>
  );
};

export default AdvisorFamilyTree;
